import { MEAL_TYPES, MEAL_TYPE_LABELS, type MealType } from "../lib/types";

interface Props {
  value: MealType;
  onChange: (next: MealType) => void;
}

export default function MealTypePicker({ value, onChange }: Props) {
  return (
    <div className="grid grid-cols-4 gap-1 bg-slate-900 border border-slate-800 rounded-lg p-1">
      {MEAL_TYPES.map((t) => (
        <button
          key={t}
          onClick={() => onChange(t)}
          className={`py-2 rounded text-xs font-medium ${
            value === t ? "bg-slate-800 text-emerald-400" : "text-slate-400"
          }`}
        >
          {MEAL_TYPE_LABELS[t]}
        </button>
      ))}
    </div>
  );
}
